import { render } from "./SpectatorHome.vue?vue&type=template&id=cc54a3a2&ts=true"
import script from "./SpectatorHome.vue?vue&type=script&lang=ts"
export * from "./SpectatorHome.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__